import { getAnimationBackgroundColor } from './getAnimationBackgroundColor';
import { ActionId } from 'owa-mail-list-item-animation-store';
export const prepareAnimations = (
    rows: Element[],
    animationAction: ActionId,
    rowItemParts: Map<string, Element[]>,
    prevChildrenPositions: Map<string, DOMRect>,
    animationRowIds: Set<string>,
    removedHeaders: Set<string>
) => {
    // When we absolutely position elements they stack on top of each other if there are not positioned items separating them.
    // We can replicate the original position by adding margin top to each item.
    if (
        animationAction != 'PinFinal' &&
        animationAction != 'UnpinFinal' &&
        animationAction != 'PinMiddle' &&
        animationAction != 'UnpinMiddle'
    ) {
        let removedElementMarginTop = 0;
        const animationBackgroundColor = getAnimationBackgroundColor(animationAction);

        const cssText = 'position: absolute; pointer-events: none; z-index:0; width: inherit;';

        const removeElement = (
            row: HTMLDivElement,
            isOnlyItemPart?: boolean,
            isGroupHeader?: boolean
        ) => {
            // absolute position the elements so we can take them out of the flow + find next position
            if (animationRowIds.has(row.id) || isOnlyItemPart || isGroupHeader) {
                row.style.cssText =
                    cssText +
                    'margin-top:' +
                    removedElementMarginTop +
                    'px;' +
                    'background:' +
                    (isGroupHeader ? 'transparent' : animationBackgroundColor) +
                    ';';

                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (68,52): Object is possibly 'undefined'.
                // @ts-ignore
                removedElementMarginTop += prevChildrenPositions.get(row.id).height;
            } else {
                removedElementMarginTop = 0;
            }
        };

        for (let index = 0; index < rows.length; index++) {
            const row = rows[index];
            // absolute position the elements so we can take them out of the flow + find next position
            const currentRowItemParts = rowItemParts.get(row.id);
            const previousElement = index > 0 && (rows[index - 1] as HTMLDivElement);
            if (
                previousElement &&
                previousElement?.id?.slice(0, 11) === 'groupHeader' &&
                animationAction != 'AddRowInitial' &&
                animationAction != 'AddRowFinal'
            ) {
                let groupHeaderStartIdx = index;

                while (animationRowIds.has(rows[groupHeaderStartIdx]?.id) && index < rows.length) {
                    groupHeaderStartIdx++;
                    if (rows[groupHeaderStartIdx]?.id.slice(0, 11) === 'groupHeader') {
                        removedHeaders.add(previousElement.id);
                        removeElement(
                            previousElement,
                            false /*itemPartOnly*/,
                            true /* isGroupHeader */
                        );
                        break;
                    }
                }
            }

            if (
                currentRowItemParts &&
                currentRowItemParts.length == 1 &&
                animationRowIds.has(currentRowItemParts[0].id)
            ) {
                removeElement(currentRowItemParts[0] as HTMLDivElement);
                removeElement(row as HTMLDivElement, true);
            } else {
                removeElement(row as HTMLDivElement);
                rowItemParts.get(row.id)?.forEach(itemPart => {
                    removeElement(itemPart as HTMLDivElement);
                });
            }
        }
    }
};
